export const NAVIGATION = {
  home: 'nav-home',
  digitalServices: 'nav-digital-services',
  products: 'nav-products',
  careers: 'nav-careers',
  blog: 'nav-blog',
  aboutUs: 'nav-about-us',
  contactUs: 'nav-contact-us',
  mobileMenuBtn: 'mobile-menu-btn',
  logo: 'nav-logo',
};

export const HERO = {
  section: 'hero-section',
  title: 'hero-title',
  subtitle: 'hero-subtitle',
  connectBtn: 'hero-connect-btn',
  learnMoreBtn: 'hero-learn-more-btn',
  prevSlide: 'hero-prev-slide',
  nextSlide: 'hero-next-slide',
};

export const PROMO = {
  section: 'promo-section',
  card1: 'promo-card-asap',
  card2: 'promo-card-strategies',
  card3: 'promo-card-expertise',
};

export const CLIENTS = {
  section: 'clients-section',
  marquee: 'clients-marquee',
};

export const ABOUT = {
  section: 'about-section',
  missionTab: 'about-mission-tab',
  visionTab: 'about-vision-tab',
  valuesTab: 'about-values-tab',
  missionContent: 'about-mission-content',
  visionContent: 'about-vision-content',
  valuesContent: 'about-values-content',
};

export const PROCESS = {
  section: 'process-section',
  step1: 'process-step-1',
  step2: 'process-step-2',
  step3: 'process-step-3',
  step4: 'process-step-4',
};

export const CONTACT = {
  section: 'contact-section',
  form: 'contact-form',
  nameInput: 'contact-name-input',
  emailInput: 'contact-email-input',
  phoneInput: 'contact-phone-input',
  messageInput: 'contact-message-input',
  submitBtn: 'contact-submit-btn',
  successMsg: 'contact-success-message',
  errorMsg: 'contact-error-message',
};

export const FOOTER = {
  section: 'footer-section',
  email: 'footer-email',
  linkedin: 'footer-linkedin',
  twitter: 'footer-twitter',
};

export const HOME = {
  emergentLink: 'home-emergent-link',
};
